
export const spanish = {
    ConfigMenu:"Menu de configuracion",
    description:"Descripcion",
    SearchBy:'Buscar por',
    successText:'Enviar',
    deleteText:'Eliminar',
    backText:'Regresar',
    cancelText:'Cancelar',
    requiredError:'Campo requerido',
    emailError: 'Email incorrecto',
    minlengthError:'La cantidad de caracteres mínimo no es el esperado',
    maxlengthError:'La cantidad de caracteres máximo no es el esperado',
    minError:'Valor inferior al mínimo',
    maxError:'Valor superior al máximo',
    patternError:'El dato ingresado no tiene el formato esperado',
    maxDate:'La fecha final no puede ser menor que la fecha inicial',
    maxTodayInicio: 'La fecha inicial no puede ser mayor a la fecha actual',
    maxTodayFin: 'La fecha final no puede ser mayor a la fecha actual',

    Queries:'Consultas',
    Query:'Consulta',
    Customers: 'Clientes',
    Customer: 'Cliente',
    Users: 'Usuarios',
    User: 'Usuario',
    Policies: 'Políticas',
    Policy: 'Política',
    CertifiedDetail: 'Histórico de Certificado Digital',
    GeneralConfigs: 'Configuraciones generales',

    ActionsAzure: 'Acciones',
    ActionAzure: 'Acción',
    AllowsAzure: 'Permisos',
    AllowAzure: 'Permiso',
    GroupsAzure: 'Grupos',
    GroupAzure: 'Grupo',
    ResourcesAzure: 'Recursos',
    ResourceAzure: 'Recurso',
    RolesAzure: 'Roles',
    RoleAzure: 'Rol',
    ActionsByRolesAzure: 'Acciones por roles',
    ActionByRoleAzure: 'Acción por rol',
    UsersByGroupsAzure: 'Usuarios por grupos',
    UserByGroupAzure: 'Usuario por grupo',

    idU: 'Código de verificación',
    certificateType: 'Id tipo de certificado',
    certificateTypeCode: 'Código tipo de certificado',
    namecertificateTypes: 'Nombre del certificado',
    maineMail: 'Correo del solicitante',
    alternativeEmail: 'Correo alterno',
    date: 'Fecha',
    dateExpired: 'Fecha de vencimiento',
    time: 'Hora modificación',
    status: 'Estado',
    responsible: 'Responsable',
    nameCertificate: 'Titulo Certificado',
    name:'Nombre',
    titleCertificate: "Titulo certificado",
    namePolicy: 'Nombre política',
    codePolicy: 'Código política',
    validationPeriod: 'Tiempo de validez',
    valididationPeriod: 'Tiempo de validez',
    policyCode: 'Código política',
    state: 'Estado',
    password: 'Contraseña',
    email: 'Usuario',
    nameArea: 'Área',
    creationDate: 'Fecha de Creacion',
    error: 'Error',
    redirectUrl: 'Url redirección portal EAFIT'

};
